import 'common/css/app.css'
import './index.css'
import 'common/js/global.js'

$(function(){
  $(window).resize(function(){
    Affix()
  })
  hoverCss()
  Affix()
  wayPoint()
})

function hoverCss() {
  $('.solution-wrapper').find('.value-item').hover(function() {
    $(this).addClass('active')
  },function(){
    $(this).removeClass('active')
  })
}
function wayPoint() {
  $('.page').waypoint(function (direction) {
      if (direction === 'down') {
          $(this.element).find('.state').addClass('animated slideInUp');
      }
  }, {offset: '70%'});
}
function Affix() {
  var affixTop = $(".solution-wrapper .offsetTop").offset().top
  $('#affixBox').affix({
    offset: {
      top: affixTop
    }
  })
}




// WEBPACK FOOTER //
// ./src/solutionVehicle/index.js